// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__fqOO5","productName":"Table_productName__1ixWy"};